import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import CopyrightText from "./CopyrightText";
import Spacer from "components/Spacer";
import GamePlatformLogos from "./logos/GamePlatformLogos";
import RatingLogo from "./logos/RatingLogo";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
        },
        ratingLogoContainer: {
            display: "flex",
            justifyContent: "center",
        },
    })
);

export default function LicensingSection() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CopyrightText />
            <Spacer size={3} />
            <GamePlatformLogos />
            <Spacer size={2} />
            <div className={classes.ratingLogoContainer}>
                <RatingLogo />
            </div>
        </div>
    );
}
